import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { DialogContent, DialogActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useDialogContentStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0)
  }
}));

const useStyles = makeStyles(theme => ({
  resourceDropdown: {
    padding: theme.spacing(3, 1, 0, 1),
    margin: theme.spacing(-2, 1, 1, 1)
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(0, 1, 1, 1),
    margin: theme.spacing(0, 1, 1, 1)
  },
  formFields: {
    padding: theme.spacing(0, 1, 0, 0),
    width: '100%'
  },
  startDate: {
    outline: 'none'
  },
  addProjectDropdown: {
    padding: theme.spacing(0, 2, 2, 2)
  },
  actionButton: {
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    }),
    margin: theme.spacing(0, 1, 0, 0)
  }
}));

const LoadingSkeleton = () => <Skeleton height={36} width={198} />;

const AllocateResourceDialogLoadingState = ({
  open,
  onClose,
  showAddProject,
  showAddUser
}) => {
  const dialogContentClasses = useDialogContentStyles();
  const classes = useStyles();

  const focusRef = useCallback(node => {
    if (node) node.focus();
  }, []);

  return (
    <>
      <DialogContent classes={dialogContentClasses}>
        {showAddProject && (
          <div className={classes.addProjectDropdown}>
            <Skeleton height={36} width={404} />
          </div>
        )}
        <div className={classes.row}>
          <div className={classes.formFields}>
            {showAddProject ? (
              <LoadingSkeleton />
            ) : (
              <Skeleton
                height={36}
                width={198}
                className={classes.startDate}
                role="textbox"
                tabIndex={0}
                ref={focusRef}
              />
            )}
          </div>
          <div className={classes.formFields}>
            <LoadingSkeleton />
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.formFields}>
            <LoadingSkeleton />
          </div>
          <div className={classes.formFields}>
            <LoadingSkeleton />
          </div>
        </div>
        {showAddUser && (
          <div className={classes.resourceDropdown}>
            <Skeleton height={36} width={404} />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <FormattedMessage id="allocateResourcesContent.cancel" />
        </Button>
        <Button
          className={classes.actionButton}
          color="primary"
          variant="contained"
          disabled
        >
          <FormattedMessage id="allocateResourcesContent.allocateResource" />
        </Button>
      </DialogActions>
    </>
  );
};

AllocateResourceDialogLoadingState.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  showAddUser: PropTypes.bool,
  showAddProject: PropTypes.bool
};

export default AllocateResourceDialogLoadingState;
